<template lang="pug">
div
  interessado-sicarf(
    :interessado="cadastro.interessado",
    :cadastrante="cadastro.cadastrante",
    :hasProcurador="true",
    :hasEspolio="true",
    :observer="observer"
    @changedTipoPessoa="changedTipoPessoa"
  )

  app-documentos(
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.interessado.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Interessado"
    @addedDoc="addedDocProcurardor"
    @removedDoc="removedDocProcurardor"
  )
</template>

<script>
import { mapActions } from 'vuex'
import InteressadoSicarf from '../../../../components/cadastro/InteressadoSicarf'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'
import _ from 'lodash'

export default {
  props: ['cadastro', 'observer'],

  components: {
    InteressadoSicarf,
    AppDocumentos
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: []
    }
  },

  async beforeRouteLeave (to, from, next) {
    await this.setDocumentosInteressado()
    await this.observer.validate({ providerName: 'Interessado/Documentos', skipIfEmpty: false })
    next()
  },

  async activated () {
    await this.setDocumentosInteressado()
  },

  computed: {
    interessado () {
      return this.cadastro.interessado
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    checkHasDocumentoProcurador (documentos) {
      let hasDocumentoProcurador = false
      documentos.forEach(
        documento => {
          if (documento.tipoDocumento.codigo === 'PROCURACAO_PUBLICA') {
            hasDocumentoProcurador = true
          }
        })
      return hasDocumentoProcurador
    },

    // Define a lista de documentos de acordo com o tipo de pessoa selecionado
    // e se existe documentos do procurador já salvos na lista de documentos do Interessado
    async setDocumentosInteressado () {
      if (this.cadastro.interessado.pessoa.tipo === 'PJ') {
        this.documentos = await this.findDocumentos('interessadoPjProcurador')
        this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoPj')

        if (this.checkHasDocumentoProcurador(this.interessado.documentos)) {
          this.documentosObrigatorios = [...this.documentosObrigatorios, ...await this.findDocumentos('obrigatorios/interessadoProcurador')]
        }
      } else {
        this.documentos = await this.findDocumentos('interessadoPfProcurador')
        this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoPf')

        if (this.checkHasDocumentoProcurador(this.interessado.documentos)) {
          this.documentosObrigatorios = [...this.documentosObrigatorios, ...await this.findDocumentos('obrigatorios/interessadoProcurador')]
        }
      }
    },

    // Se um documento relacionado ao Procurador for anexado são adicionados à lista de obrigatórios os demais documentos do Procurador
    async addedDocProcurardor (doc) {
      if (doc.tipoDocumento.codigo === 'PROCURACAO_PUBLICA') {
        const obrigatorios = await this.findDocumentos('/obrigatorios/interessadoProcurador')
        const docs = this.cadastro.interessado.pessoa.tipo === 'PJ' ? await this.findDocumentos('interessadoPjProcurador')
          : await this.findDocumentos('interessadoPfProcurador')

        this.documentos = _.uniqBy([...docs, ...obrigatorios], 'codigo')
        this.documentosObrigatorios = [...this.documentosObrigatorios, ...obrigatorios]

        this.$nextTick(async () => {
          await this.observer.validate({ providerName: 'Interessado/Documentos' })
        })
      }
    },

    // Se todos os documentos relacionados ao Procurador forem removidos os mesmos são retirados da lista de obrigatórios
    async removedDocProcurardor (doc) {
      if (doc.tipoDocumento.codigo === 'PROCURACAO_PUBLICA') {
        if (!this.checkHasDocumentoProcurador(this.interessado.documentos)) {
          this.documentos = this.cadastro.interessado.pessoa.tipo === 'PJ' ? await this.findDocumentos('interessadoPjProcurador')
            : await this.findDocumentos('interessadoPfProcurador')
          this.documentosObrigatorios = this.interessado.pessoa.tipo === 'PF' ? await this.findDocumentos('obrigatorios/interessadoPf')
            : await this.findDocumentos('obrigatorios/interessadoPj')

          this.$nextTick(async () => {
            await this.observer.validate({ providerName: 'Interessado/Documentos' })
          })
        }
      }
    },

    async changedTipoPessoa (tipo) {
      await this.setDocumentosInteressado()
    }
  },

  watch: {
    'interessado.pessoa.tipo': {
      async handler () {
        await this.setDocumentosInteressado()
        this.observer.reset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/solicitarInformacao/components/Interessado.vue